import Controller from 'lib/controller'

// A generic controller that does nothing but initialize the base controller.
// Used for pages that don't have their own controller and just want the functionality
// that comes from instantiating application.js
new Controller()
